module.exports = __webpack_public_path__ + "img/loading_blk.ef30aeb1.svg";